// Angular
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { IConfig } from '@core/config/config.interface';
// Env
import { environment } from '@env/environment';
// Services
import { ConfigService } from '@core/config/config.service';
import { SellerTopbar } from '../topbar/seller-topbar.interface';

@Component({
  selector: 'app-topbar-mobile',
  templateUrl: './topbar-mobile.component.html',
  styleUrls: ['./topbar-mobile.component.scss'],
})
export class TopbarMobileComponent implements OnInit {
  logoSrc = environment.logoSrc;
  config: IConfig;
  seller: SellerTopbar | null = null;
  isSellerExpanded = false;

  constructor(
    private readonly router: Router,
    private readonly configService: ConfigService,
    private readonly route: ActivatedRoute
  ) {
    this.config = this.configService.getConfig();
    this.getQueryParams();
  }

  ngOnInit() {
    this.Hide_menub2c();
  }

  Hide_menub2c() {
    if (this.router.url.includes('/carro-compra/')) {
      return false;
    } else {
      return true;
    }
  }

  navegar() {
    this.router.navigate(['/inicio']);
  }

  toggleSellerInfo() {
    this.isSellerExpanded = !this.isSellerExpanded;
  }

  private getQueryParams(): void {
    this.route.queryParams.subscribe((params) => {
      if (params['nombre'] || params['correo'] || params['telefono']) {
        this.seller = {
          name: params['nombre'] || '-',
          email: params['correo'] || '-',
          phone: params['telefono'] || '-',
        };
      }
    });
  }
}
